export default "__VITE_ASSET__BaT8sKqI__"